import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActors,
  selectSelectedElement,
  selectSelectedElementType,
  selectSelectedTake3D,
  setSelectedTake,
} from "../../app/slices/TrainingSlice";
import { SelectedTab, selectSelectedTab } from "../../app/slices/GlobalSlice";
import { ActorState } from "../../models/ActorState";
import ActorStatePropertiesEditor from "../actor_state_properties_column/ActorStatePropertiesEditor";
import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";

export default function ViewportActorStateWindow() {
  const dispatch = useDispatch();
  const selectedTab = useSelector(selectSelectedTab);
  const selectedElementType = useSelector(selectSelectedElementType);
  const selectedActorState = useSelector(selectSelectedElement) as
    | ActorState
    | undefined;
  const selectedTake = useSelector(selectSelectedTake3D);
  const actorPreset = useSelector(selectActors).find(
    (actor) => actor.id === selectedActorState?.actorId,
  );

  const isVisible = useMemo(() => {
    return (
      selectedTab === SelectedTab.Timeline &&
      selectedElementType === "actor" &&
      selectedActorState !== undefined &&
      selectedTake !== undefined
    );
  }, [selectedActorState, selectedElementType, selectedTab, selectedTake]);

  if (!isVisible || !selectedTake) return null;

  const title = (
    <div className="viewport3d-actor-window__title-wrap">
      <div className="viewport3d-actor-window__icon">
        <PermIdentityOutlinedIcon fontSize="inherit" color="inherit" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="viewport3d-actor-window__eyebrow">Actor Settings</div>
        <div
          className="viewport3d-actor-window__title"
          title={actorPreset?.workingName ?? "Actor"}
        >
          {actorPreset?.workingName ?? "Actor"}
        </div>
      </div>
      <button
        type="button"
        aria-label="Close actor settings"
        className="viewport3d-actor-window__close"
        onClick={() => dispatch(setSelectedTake(selectedTake.id))}
      >
        <CloseOutlinedIcon fontSize="inherit" color="inherit" />
      </button>
    </div>
  );

  return (
    <aside
      aria-label="viewport-actor-state-window"
      className="viewport3d-actor-window"
    >
      <PiPopupWindowPreview
        title={title}
        size="large"
        body={
          <div className="viewport3d-actor-window__body pit-creator-scrollbar">
            <ActorStatePropertiesEditor layout="tiles" />
          </div>
        }
      />
    </aside>
  );
}
